import { cn } from "@/lib/utils";

const STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  reviewed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  normal: "bg-emerald-50 text-emerald-700 border-emerald-200",
  due: "bg-sky-50 text-sky-700 border-sky-200",
  pending_review: "bg-amber-50 text-amber-700 border-amber-200",
  paused: "bg-amber-50 text-amber-700 border-amber-200",
  overdue: "bg-red-50 text-red-700 border-red-200",
  high: "bg-red-50 text-red-700 border-red-200",
  low: "bg-amber-50 text-amber-700 border-amber-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
  ended: "bg-slate-100 text-slate-600 border-slate-200",
};

const LABELS = {
  pending_review: "Pending Review",
  front_desk: "Front Desk",
};

export default function StatusBadge({ status, testid }) {
  const label = LABELS[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : "—");
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200"
      )}
    >
      {label}
    </span>
  );
}
